module.exports = __webpack_public_path__ + "img/new-years.64ee00cf.jpeg";